module.exports = __webpack_public_path__ + "img/meditation.b5050c9d.svg";